// extracted by mini-css-extract-plugin
export var scrollDepthIndicator = "scrollDepthIndicator-module--scrollDepthIndicator--c5c60";